export class Strategy {
  name: string;
  title: string;
  description: string;
  assignable: string[];
  properties: string[];
  allowedDomains: string[];
  icon: string;
}

export class Facet {
  name: string;
  title: string;
  description: string;
  segmentable: boolean;
  strategies: string[];
}

export interface PlannerError {
  devMessage: string;
  arg: string;
}

export interface EventInfo {
  name: string;
  type: string;
  facets: string[];
  valueType: string;
  service: string;
  description: string;
  lastSeen: number;
  count: number;
}

export interface LoginResponse {
  token: string;
  expiredAt: number;
}

export class City {
  id: number;
  countryCode: string;
  name: string;
  timeZone: string;
  countryID?: number;
}

export class Country {
  Code: string;
  CurrencySymbol: string;
  ID: number;
  ISOCurrency: string;
  Locale: string;
  Name: string;
  Region: string;
  countryCode: string;
  countryID?: number;
  name?: string;
  IsOperationalCountry?: boolean;
}

export class Vehicle {
  id: number;
  cityID: number;
  name: string;
  serviceType: string;
  icon: string;
  active?: boolean;
}

export interface SelectableItems {
  getValue?(): string;
}

export class Group implements SelectableItems {
  public constructor(
    public name: string,
    public facet?: string,
    public strategy?: string,
    public value?: string,
    public source?: string,
    public version?: number,
    public members?: string[],
    public schedule?: string,
    public cityID?: number,
    public countryID?: number,
  ) {
    this.name = name;
    this.facet = facet;
    this.strategy = strategy;
    this.value = value;
    this.source = source;
    this.version = version;
    this.members = members;
    this.schedule = schedule;
  }

  public getValue?(): string {
    return this.name;
  }
}

export interface Script {
  name: string;
  version: number;
  code: string;
  facets: string[];
  returnType: string;
  backendService: string;
  owner: string;
}

export interface ScriptTableData {
  name: string;
  facetsString: string;
  returnType: string;
  backendService: string;
  owner: string;
}

export class BackendService {
  prefix: string;
  title: string;
  family: string;
}

export interface ServiceItem {
  name: string;
  is_helix: boolean;
  lifecycle?: string;
  helix_name?: string;
}

export class TechFamily {
  prefix: string;
  title: string;
}

export interface TechFamilyItem {
  name: string;
  is_helix: boolean;
  helix_name?: string;
}

export class Tag implements SelectableItems {
  public constructor(
    public id: number,
    public key: string,
    public value: string,
  ) {
    this.id = id;
    this.key = key;
    this.value = value;
  }

  public getValue?(): string {
    return this.value;
  }
}

export class ExperimentMonitorInfo {
  count: number;
  end: Date;
  experiment: string;
  points: number[][];
  start: Date;
  updatedAt: Date;
  variable: string;
}

export class NextSchedule {
  name: string;
  next: Date;
  schedule: string;
}

export interface StaticValue {
  value: number;
  string: string;
}

export interface GenericValue {
  value: number;
  string: string;
  script?: string;
}

export interface PaginatedResponse<T> {
  items: T;
  limit: number;
  offset: number;
  total: number;
  totalCount?: number;
}

export interface ProductConfigurationsRequest {
  search_term: string;
  variable_filters: { [key: string]: any };
  offset: number;
  limit: number;
  sortBy?: string;
  ordering?: string;
}
